<!--页头面包屑-->
<template>
  <div class="breadcrumb">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item
        v-for="(item, index) in routeInfo"
        :key="index"
        :to="routePath(item, index)"
        :replace="true"
      >{{ item ? item.name : "" }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import Bus from "../../scripts/bus";
import breadcrumb from "./breadcrumb";
export default {
  mixins: [breadcrumb],
  name: "Breadcrumb",
  data() {
    return {
      routeList: [],
      queryData: {},
      routeInfo: [],
    };
  },
  watch: {
    menuRoute: {
      deep: true,
      immediate: true,
      handler(val) {
        this.routeInfo = val;
        // this.queryData = {};
        if (val&&val.length) {
          this.routeList = val;
          this.getBus();
        }
      },
    },
  },
  created() {
    // this.queryData = {};
    this.getBus();
  },
  methods: {
    // 获取兄弟组件传来的值
    getBus() {
      var _this = this;
      Bus.$on("getQueryInfo", (data) => { 
        _this.queryData = data;
      });
    },
    getIcon(list) {
      let iconList = [];
      list.forEach((el) => {
        if (el.icon) {
          iconList.push(el.icon);
        }
      });
      return iconList[iconList.length - 1] || "";
    },
    /**面包屑路由跳转 item, index*/
    routePath(item, index) {
      let path = "";
      let length = this.routeInfo.length;
      if (length == 1) {
        // path = {
        //   path: item.path,
        // };
        path = null;
      } else {
        if (item.type != 0) {
          if (index < length - 1) {
            if (index != 0) {
              path = {
                path: this.removeRepetition(
                  this.routeInfo[0].path + "/" + item.path
                ),
                query: this.queryData[item.path] || {},
              };
            } else {
              path = {
                path: this.removeRepetition(item.path),
              };
            }
          }
        }
      }
      return path;
    },
    /**去除相邻重复 */
    removeRepetition(path) {
      let path_arr = path.split("/");
      let path_str = "";

      for (var i = 0; i < path_arr.length; i++) {
        if (path_arr[i] != path_arr[i + 1]) {
          let unit = "";
          if (i < path_arr.length - 1) {
            unit = "/";
          }
          path_str = path_str + path_arr[i] + unit;
        }
      }
      return path_str;
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  
  background: #fff;
  padding: 16px;
  /deep/.el-breadcrumb {
    font-size: 14px;
    font-weight: 500;

    .el-breadcrumb__separator {
      font-weight: normal;
    }
    .el-breadcrumb__item {
      color: $fontColor;
      .el-breadcrumb__inner {
        color: $fontColor;
        &.is-link {
          font-weight: normal;
        }
      }
      .el-breadcrumb__separator {
        color: $fontColor;
      }

      &:not(:last-child) {
        // opacity: 0.3;
        .el-breadcrumb__inner,
        .el-breadcrumb__separator {
          color: #606871;
        }
      }
    }
  }
}
</style>
